'use strict';
const angular = require('angular');

export class EmailSectionEditComponent {
  /*@ngInject*/
  constructor(SettingsService) {
    this.emails = [];
    this.SettingsService = SettingsService;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("data")) {
      this.emails = this.config.data ? angular.copy(this.config.data) : [];
    }

    this.SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.mailTypes = appSettings.data.mailTypes;

      if (!this.emails || !this.emails.length)
        this.addEmail();
    });
  };

  updatePrimaryEmail(idx) {
    angular.forEach(this.emails, (email, index) => {
      email.isPrimary = (idx == index);
    });
  }

  addEmail() {
    this.emails.push({
      type: this.mailTypes[0] || '-',
      address: '',
      isPrimary: !this.emails.length
    })
  }

  removeEmail(idx) {
    // Check if the removed phone was the primary one
    let primaryRemoved = this.emails[idx].isPrimary;

    // remove the phone
    this.emails.splice(idx,1);

    // if the feature image is removed and there are still images in the gallery,
    // set the feature image to the first image in the gallery
    if (primaryRemoved && this.emails.length > 0) {
      this.emails[0].isPrimary = true;
    }
  }

  ok() {
    this.close({$value: this.emails});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.emailSectionEdit', [])
  .component('emailSectionEdit', {
    template: require('./email-section-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: EmailSectionEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/email-section-edit/email-section-edit.component.js